// Per-tab session id used as session_id in agent_actions audit log.
const KEY = 'expai-agent-session-id';

const newId = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `sess-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export function getOrCreateSessionId(): string {
  if (typeof window === 'undefined') return 'ssr';
  try {
    const existing = window.sessionStorage.getItem(KEY);
    if (existing) return existing;
    const fresh = newId();
    window.sessionStorage.setItem(KEY, fresh);
    return fresh;
  } catch {
    return newId();
  }
}

export function newIdempotencyKey(): string {
  return newId();
}
